module.exports = __webpack_public_path__ + "static/media/background-image1.43757ed2.png";